const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://docs.ratehr.com',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: 'https://ratehr.com/_next/static/media/logo.414e1eac.png',
    logoLink: 'https://ratehr.com',
    title:
      "<a href='https://ratehr.com'><img class='img-responsive' src='https://ratehr.com/_next/static/media/logo.414e1eac.png' /></a>",
    // githubUrl: 'https://github.com/hasura/gatsby-gitbook-boilerplate',
    helpUrl: '',
    tweetText: '',
    // social: `<li>
    //     <a href="https://twitter.com/hasurahq" target="_blank" rel="noopener">
    //       <div class="twitterBtn">
    //         <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/twitter-brands-block.svg' alt={'Twitter'}/>
    //       </div>
    //     </a>
    //   </li>
    // 	<li>
    //     <a href="https://discordapp.com/invite/hasura" target="_blank" rel="noopener">
    //       <div class="discordBtn">
    //         <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/discord-brands-block.svg' alt={'Discord'}/>
    //       </div>
    //     </a>
    //   </li>`,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      'RateOP',
      '/Terms and Conditions', // add trailing slash if enabled above
      '/Privacy Policy',
    ],
    // collapsedNav: [
    //   '/codeblock', // add trailing slash if enabled above
    // ],
    links: [{ text: 'RateOP', link: 'https://play.google.com/store/apps/details?id=com.app.rateop' }],
    frontLine: false,
    ignoreIndex: true,
    title:
      "<a href='https://play.google.com/store/apps/details?id=com.app.rateop'>RateOP </a><div class='greenCircle'></div><a href='https://docs.ratehr.com/'>Documentation</a>",
  },
  siteMetadata: {
    title: 'RateOP',
    description: 'RateOP Documentations',
    ogImage: null,
    docsLocation: 'https://docs.ratehr.com',
    favicon: 'https://ratehr.com/_next/static/media/logo.414e1eac.png',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Gatsby Gitbook Starter',
      short_name: 'GitbookStarter',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
